// src/store/store.js
import { configureStore } from '@reduxjs/toolkit';
import authReducer from "./slices/authSlice";
import productReducer from './slices/productSlice';
import appointmentReducer from './slices/appointmentSlice';
import clientReducer from './slices/clientSlice';
import membershipReducer from './slices/membershipSlice';
import dashboardReducer from './slices/dashboardSlice';
import salesAnalyticsReducer from './slices/salesAnalyticsSlice';
import headerReducer from './slices/headerSlice';
import billReducer from './slices/billSlice';
import allBillingReducer from "./slices/AllBillingSlice"
import serviceReducer from './slices/servicesSlice';
import expenseReducer from './slices/expenseSlice';
import couponReducer from './slices/couponSlice';
import notificationReducer from './slices/notificationSlice';
import staffReducer from './slices/staffSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    product: productReducer,
    appointments: appointmentReducer,
    clients: clientReducer,
    memberships: membershipReducer,
    dashboard: dashboardReducer,
    salesAnalytics: salesAnalyticsReducer,
    header: headerReducer,
    bill: billReducer,
    // membershipBill : membershipBillReducer,
    // packageBill : packageBillReducer,
    allBilling: allBillingReducer,
    service: serviceReducer,
    expenses: expenseReducer,
    coupons: couponReducer,
    staffs: staffReducer,
    notifications: notificationReducer,
  },
});

export default store;